"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CLOCK_WRAPPER_BACKGROUND = void 0; // clock wrapper

var CLOCK_WRAPPER_BACKGROUND = '#f4f4f4';
exports.CLOCK_WRAPPER_BACKGROUND = CLOCK_WRAPPER_BACKGROUND;